var map = {
	".": 300,
	"./": 300,
	"./api/deterministicJSON": 566,
	"./api/deterministicJSON.js": 566,
	"./api/gql": 110,
	"./api/gql.js": 110,
	"./api/ipfs": 344,
	"./api/ipfs.js": 344,
	"./assets/constants/abi/BPool": 194,
	"./assets/constants/abi/BPool.json": 194,
	"./assets/constants/abi/DelegateCallProxyManager": 567,
	"./assets/constants/abi/DelegateCallProxyManager.json": 567,
	"./assets/constants/abi/GovernorAlpha": 180,
	"./assets/constants/abi/GovernorAlpha.json": 180,
	"./assets/constants/abi/IERC20": 230,
	"./assets/constants/abi/IERC20.json": 230,
	"./assets/constants/abi/IStakingRewards": 203,
	"./assets/constants/abi/IStakingRewards.json": 203,
	"./assets/constants/abi/IUniswapV2Pair": 243,
	"./assets/constants/abi/IUniswapV2Pair.json": 243,
	"./assets/constants/abi/IndexedUniswapRouterMinter": 568,
	"./assets/constants/abi/IndexedUniswapRouterMinter.json": 568,
	"./assets/constants/abi/MarketCapSqrtController": 569,
	"./assets/constants/abi/MarketCapSqrtController.json": 569,
	"./assets/constants/abi/MetaGovernorCOMP": 833,
	"./assets/constants/abi/MetaGovernorCOMP.json": 833,
	"./assets/constants/abi/MetaGovernorUNI": 834,
	"./assets/constants/abi/MetaGovernorUNI.json": 834,
	"./assets/constants/abi/MockERC20": 570,
	"./assets/constants/abi/MockERC20.json": 570,
	"./assets/constants/abi/MultiTokenStaking": 286,
	"./assets/constants/abi/MultiTokenStaking.json": 286,
	"./assets/constants/abi/Ndx": 198,
	"./assets/constants/abi/Ndx.json": 198,
	"./assets/constants/abi/PoolFactory": 571,
	"./assets/constants/abi/PoolFactory.json": 571,
	"./assets/constants/abi/PoolInitializer": 199,
	"./assets/constants/abi/PoolInitializer.json": 199,
	"./assets/constants/abi/ProxyManagerAccessControl": 572,
	"./assets/constants/abi/ProxyManagerAccessControl.json": 572,
	"./assets/constants/abi/RewardsSchedule": 835,
	"./assets/constants/abi/RewardsSchedule.json": 835,
	"./assets/constants/abi/SigmaControllerV1": 573,
	"./assets/constants/abi/SigmaControllerV1.json": 573,
	"./assets/constants/abi/StakingRewardsFactory": 334,
	"./assets/constants/abi/StakingRewardsFactory.json": 334,
	"./assets/constants/abi/UniswapV2Router": 574,
	"./assets/constants/abi/UniswapV2Router.json": 574,
	"./assets/constants/addresses": 31,
	"./assets/constants/addresses.js": 31,
	"./assets/constants/categories/0x1": 836,
	"./assets/constants/categories/0x1.json": 836,
	"./assets/constants/categories/0x2": 837,
	"./assets/constants/categories/0x2.json": 837,
	"./assets/constants/categories/0x3": 838,
	"./assets/constants/categories/0x3.json": 838,
	"./assets/constants/categories/sigma-v10x1": 839,
	"./assets/constants/categories/sigma-v10x1.json": 839,
	"./assets/constants/categories/sigma-v10x2": 840,
	"./assets/constants/categories/sigma-v10x2.json": 840,
	"./assets/constants/categories/sigma-v10x3": 841,
	"./assets/constants/categories/sigma-v10x3.json": 841,
	"./assets/constants/categories/sigma-v10x4": 842,
	"./assets/constants/categories/sigma-v10x4.json": 842,
	"./assets/constants/functions": 29,
	"./assets/constants/functions.js": 29,
	"./assets/constants/parameters": 2,
	"./assets/constants/parameters.js": 2,
	"./assets/constants/urls": 843,
	"./assets/constants/urls.js": 843,
	"./assets/constants/whitelists/limited-mainnet-tokens": 541,
	"./assets/constants/whitelists/limited-mainnet-tokens.json": 541,
	"./assets/constants/whitelists/rinkeby-tokens": 540,
	"./assets/constants/whitelists/rinkeby-tokens.json": 540,
	"./assets/css": 27,
	"./assets/css/": 27,
	"./assets/css/components/approvals": 115,
	"./assets/css/components/approvals.js": 115,
	"./assets/css/components/banner": 347,
	"./assets/css/components/banner.js": 347,
	"./assets/css/components/burn": 844,
	"./assets/css/components/burn.js": 844,
	"./assets/css/components/flag": 342,
	"./assets/css/components/flag.js": 342,
	"./assets/css/components/footer": 341,
	"./assets/css/components/footer.js": 341,
	"./assets/css/components/form": 426,
	"./assets/css/components/form.js": 426,
	"./assets/css/components/list": 427,
	"./assets/css/components/list.js": 427,
	"./assets/css/components/mint": 235,
	"./assets/css/components/mint.js": 235,
	"./assets/css/components/modal": 234,
	"./assets/css/components/modal.js": 234,
	"./assets/css/components/navigation": 340,
	"./assets/css/components/navigation.js": 340,
	"./assets/css/components/pie": 428,
	"./assets/css/components/pie.js": 428,
	"./assets/css/components/spline": 429,
	"./assets/css/components/spline.js": 429,
	"./assets/css/components/table": 348,
	"./assets/css/components/table.js": 348,
	"./assets/css/components/tabs": 349,
	"./assets/css/components/tabs.js": 349,
	"./assets/css/components/trade": 161,
	"./assets/css/components/trade.js": 161,
	"./assets/css/components/weights": 274,
	"./assets/css/components/weights.js": 274,
	"./assets/css/index": 27,
	"./assets/css/index.js": 27,
	"./assets/css/root.css": 832,
	"./assets/css/routes": 231,
	"./assets/css/routes/": 231,
	"./assets/css/routes/categories": 350,
	"./assets/css/routes/categories.js": 350,
	"./assets/css/routes/category": 351,
	"./assets/css/routes/category.js": 351,
	"./assets/css/routes/governance": 352,
	"./assets/css/routes/governance.js": 352,
	"./assets/css/routes/index": 231,
	"./assets/css/routes/index.js": 231,
	"./assets/css/routes/markets": 353,
	"./assets/css/routes/markets.js": 353,
	"./assets/css/routes/pool": 204,
	"./assets/css/routes/pool.js": 204,
	"./assets/css/routes/portfolio": 354,
	"./assets/css/routes/portfolio.js": 354,
	"./assets/css/routes/proposal": 355,
	"./assets/css/routes/proposal.js": 355,
	"./assets/css/routes/propose": 356,
	"./assets/css/routes/propose.js": 356,
	"./assets/css/routes/root": 357,
	"./assets/css/routes/root.js": 357,
	"./assets/css/routes/stake": 148,
	"./assets/css/routes/stake.js": 148,
	"./assets/css/routes/supply": 205,
	"./assets/css/routes/supply.js": 205,
	"./assets/css/routes/swap": 845,
	"./assets/css/routes/swap.js": 845,
	"./assets/fonts/aux-mono/aux-mono.otf": 1518,
	"./assets/images/aave.png": 636,
	"./assets/images/ampl.png": 628,
	"./assets/images/bal.png": 630,
	"./assets/images/bat.png": 629,
	"./assets/images/busd.png": 625,
	"./assets/images/cc-dark-circular.png": 647,
	"./assets/images/cc-dark.png": 642,
	"./assets/images/cc-light-circular.png": 648,
	"./assets/images/cc-light.png": 641,
	"./assets/images/comp.png": 624,
	"./assets/images/crv.png": 634,
	"./assets/images/dai.png": 622,
	"./assets/images/defi-dark-circular.png": 645,
	"./assets/images/defi-dark.png": 644,
	"./assets/images/defi-light-circular.png": 646,
	"./assets/images/defi-light.png": 643,
	"./assets/images/defi-pulse.png": 656,
	"./assets/images/degen-light-circular.png": 290,
	"./assets/images/discord.png": 650,
	"./assets/images/discourse.png": 654,
	"./assets/images/error-dark-circular.png": 470,
	"./assets/images/error-light-circular.png": 471,
	"./assets/images/eth.png": 620,
	"./assets/images/etherscan.png": 659,
	"./assets/images/fff-dark-circular.png": 472,
	"./assets/images/fff-light-circular.png": 473,
	"./assets/images/github.png": 651,
	"./assets/images/indexed-dark.png": 339,
	"./assets/images/indexed-light.png": 338,
	"./assets/images/knc.png": 626,
	"./assets/images/link.png": 627,
	"./assets/images/medium.png": 652,
	"./assets/images/mkr.png": 621,
	"./assets/images/nftp-dark-circular.png": 469,
	"./assets/images/nftp-light-circular.png": 468,
	"./assets/images/omg.png": 639,
	"./assets/images/orcl-dark-circular.png": 466,
	"./assets/images/orcl-light-circular.png": 467,
	"./assets/images/ren.png": 640,
	"./assets/images/snapshot.png": 655,
	"./assets/images/snx.png": 631,
	"./assets/images/twitter.png": 653,
	"./assets/images/uma.png": 638,
	"./assets/images/uni.png": 337,
	"./assets/images/usdc.png": 635,
	"./assets/images/usdt.png": 633,
	"./assets/images/wbtc.png": 623,
	"./assets/images/yfi.png": 632,
	"./assets/images/zrx.png": 637,
	"./components/NewStakingCard": 430,
	"./components/NewStakingCard.tsx": 430,
	"./components/StakingCard": 358,
	"./components/StakingCard.tsx": 358,
	"./components/banner": 431,
	"./components/banner.js": 431,
	"./components/buttons/adornment": 236,
	"./components/buttons/adornment.js": 236,
	"./components/buttons/etherscan-link": 100,
	"./components/buttons/etherscan-link.js": 100,
	"./components/buttons/market": 103,
	"./components/buttons/market.js": 103,
	"./components/buttons/primary": 39,
	"./components/buttons/primary.js": 39,
	"./components/buttons/secondary": 275,
	"./components/buttons/secondary.js": 275,
	"./components/buttons/transaction": 287,
	"./components/buttons/transaction.js": 287,
	"./components/buttons/web3-required-primary": 90,
	"./components/buttons/web3-required-primary.tsx": 90,
	"./components/canvas": 73,
	"./components/canvas.js": 73,
	"./components/card": 232,
	"./components/card.js": 232,
	"./components/charts/IndexChartContainer": 432,
	"./components/charts/IndexChartContainer.tsx": 432,
	"./components/charts/area": 433,
	"./components/charts/area.tsx": 433,
	"./components/charts/pie": 434,
	"./components/charts/pie.js": 434,
	"./components/charts/spline": 200,
	"./components/charts/spline.js": 200,
	"./components/charts/stacked": 435,
	"./components/charts/stacked.js": 435,
	"./components/container": 61,
	"./components/container.js": 61,
	"./components/flag": 423,
	"./components/flag.js": 423,
	"./components/footer": 422,
	"./components/footer.js": 422,
	"./components/hooks/useTokenAmount": 862,
	"./components/hooks/useTokenAmount.js": 862,
	"./components/index/burn-form": 436,
	"./components/index/burn-form.js": 436,
	"./components/index/burn-tab": 360,
	"./components/index/burn-tab.tsx": 360,
	"./components/index/mint-form": 863,
	"./components/index/mint-form.js": 863,
	"./components/index/mint-tab": 361,
	"./components/index/mint-tab.js": 361,
	"./components/index/swap": 362,
	"./components/index/swap.js": 362,
	"./components/index/tabs": 446,
	"./components/index/tabs.js": 446,
	"./components/index/trade-input": 363,
	"./components/index/trade-input.js": 363,
	"./components/index/trade-tab": 364,
	"./components/index/trade-tab.js": 364,
	"./components/index/uniswap-minter": 443,
	"./components/index/uniswap-minter.js": 443,
	"./components/index/weighted-token": 448,
	"./components/index/weighted-token.js": 448,
	"./components/inputs/adornment": 335,
	"./components/inputs/adornment.js": 335,
	"./components/inputs/exchange": 239,
	"./components/inputs/exchange.js": 239,
	"./components/inputs/input": 58,
	"./components/inputs/input.js": 58,
	"./components/inputs/radio": 207,
	"./components/inputs/radio.js": 207,
	"./components/inputs/search": 869,
	"./components/inputs/search.js": 869,
	"./components/inputs/select": 289,
	"./components/inputs/select.js": 289,
	"./components/inputs/slippage": 442,
	"./components/inputs/slippage.js": 442,
	"./components/inputs/toggle": 870,
	"./components/inputs/toggle.js": 870,
	"./components/inputs/token-input": 276,
	"./components/inputs/token-input.js": 276,
	"./components/inputs/token-inputs": 277,
	"./components/inputs/token-inputs.js": 277,
	"./components/inputs/token-output": 437,
	"./components/inputs/token-output.js": 437,
	"./components/inputs/whitelist-select": 585,
	"./components/inputs/whitelist-select.js": 585,
	"./components/lineprogress": 451,
	"./components/lineprogress.js": 451,
	"./components/list": 146,
	"./components/list.js": 146,
	"./components/loader": 331,
	"./components/loader.js": 331,
	"./components/loaders/area": 452,
	"./components/loaders/area.js": 452,
	"./components/loaders/spline": 359,
	"./components/loaders/spline.js": 359,
	"./components/loaders/stake": 453,
	"./components/loaders/stake.js": 453,
	"./components/loaders/tabs": 447,
	"./components/loaders/tabs.js": 447,
	"./components/loaders/title": 454,
	"./components/loaders/title.js": 454,
	"./components/modal": 332,
	"./components/modal.js": 332,
	"./components/navigation": 421,
	"./components/navigation.js": 421,
	"./components/pool/explain-credit": 279,
	"./components/pool/explain-credit.js": 279,
	"./components/pool/initialized-pool": 455,
	"./components/pool/initialized-pool.js": 455,
	"./components/pool/initializer-form": 457,
	"./components/pool/initializer-form.js": 457,
	"./components/pool/uninitialized-pool": 459,
	"./components/pool/uninitialized-pool.js": 459,
	"./components/progress": 208,
	"./components/progress.js": 208,
	"./components/table": 460,
	"./components/table.js": 460,
	"./components/utils/copyable": 162,
	"./components/utils/copyable.tsx": 162,
	"./components/utils/delta": 182,
	"./components/utils/delta.js": 182,
	"./components/utils/popper": 238,
	"./components/utils/popper.js": 238,
	"./components/weights": 280,
	"./components/weights.js": 280,
	"./components/wrapper": 461,
	"./components/wrapper.js": 461,
	"./hooks/useDebounce": 278,
	"./hooks/useDebounce.ts": 278,
	"./hooks/useNewStakingPools": 871,
	"./hooks/useNewStakingPools.ts": 871,
	"./hooks/useRewards": 181,
	"./hooks/useRewards.ts": 181,
	"./hooks/useTimeout": 450,
	"./hooks/useTimeout.ts": 450,
	"./hooks/useUniswapPairs": 273,
	"./hooks/useUniswapPairs.ts": 273,
	"./hooks/useWeb3": 122,
	"./hooks/useWeb3.ts": 122,
	"./index": 300,
	"./index.tsx": 300,
	"./lib/copyToClipboard": 456,
	"./lib/copyToClipboard.tsx": 456,
	"./lib/erc20": 81,
	"./lib/erc20.js": 81,
	"./lib/markets": 336,
	"./lib/markets.js": 336,
	"./lib/util/bn": 873,
	"./lib/util/bn.js": 873,
	"./lib/util/contracts": 41,
	"./lib/util/contracts.js": 41,
	"./lib/util/deterministicJSON": 586,
	"./lib/util/deterministicJSON.js": 586,
	"./lib/util/ipfs": 874,
	"./lib/util/ipfs.js": 874,
	"./react-app-env.d": 899,
	"./react-app-env.d.ts": 899,
	"./routes": 328,
	"./routes/": 328,
	"./routes/404": 599,
	"./routes/404.js": 599,
	"./routes/categories": 600,
	"./routes/categories.js": 600,
	"./routes/category": 601,
	"./routes/category.js": 601,
	"./routes/governance": 606,
	"./routes/governance.js": 606,
	"./routes/index": 328,
	"./routes/index.js": 328,
	"./routes/markets": 607,
	"./routes/markets.js": 607,
	"./routes/pool": 608,
	"./routes/pool.js": 608,
	"./routes/portfolio": 609,
	"./routes/portfolio.js": 609,
	"./routes/proposal": 610,
	"./routes/proposal.js": 610,
	"./routes/propose": 612,
	"./routes/propose.js": 612,
	"./routes/root": 910,
	"./routes/root.js": 910,
	"./routes/stake": 613,
	"./routes/stake.js": 613,
	"./routes/supply": 614,
	"./routes/supply-new": 615,
	"./routes/supply-new.js": 615,
	"./routes/supply.js": 614,
	"./state": 24,
	"./state/": 24,
	"./state/actions/burn-actions": 911,
	"./state/actions/burn-actions.tsx": 911,
	"./state/actions/initializer-actions": 912,
	"./state/actions/initializer-actions.tsx": 912,
	"./state/actions/mint-actions": 913,
	"./state/actions/mint-actions.tsx": 913,
	"./state/actions/swap-actions": 914,
	"./state/actions/swap-actions.tsx": 914,
	"./state/actions/trade-actions": 915,
	"./state/actions/trade-actions.tsx": 915,
	"./state/actions/uniswap-minter-actions": 916,
	"./state/actions/uniswap-minter-actions.tsx": 916,
	"./state/burn": 237,
	"./state/burn.tsx": 237,
	"./state/index": 24,
	"./state/index.js": 24,
	"./state/initializer": 163,
	"./state/initializer.tsx": 163,
	"./state/middleware": 75,
	"./state/middleware/": 75,
	"./state/middleware/burn-middleware": 408,
	"./state/middleware/burn-middleware.tsx": 408,
	"./state/middleware/index": 75,
	"./state/middleware/index.tsx": 75,
	"./state/middleware/initializer-middleware": 409,
	"./state/middleware/initializer-middleware.tsx": 409,
	"./state/middleware/mint-middleware": 407,
	"./state/middleware/mint-middleware.tsx": 407,
	"./state/middleware/swap-middleware": 445,
	"./state/middleware/swap-middleware.tsx": 445,
	"./state/middleware/trade-middleware": 272,
	"./state/middleware/trade-middleware.tsx": 272,
	"./state/middleware/uniswap-minter-middleware": 441,
	"./state/middleware/uniswap-minter-middleware.tsx": 441,
	"./state/mint": 183,
	"./state/mint.tsx": 183,
	"./state/new-staking/context": 197,
	"./state/new-staking/context.tsx": 197,
	"./state/new-staking/hooks": 425,
	"./state/new-staking/hooks.ts": 425,
	"./state/new-staking/reducer": 346,
	"./state/new-staking/reducer.ts": 346,
	"./state/reducers/burn-reducer": 438,
	"./state/reducers/burn-reducer.tsx": 438,
	"./state/reducers/initializer-reducer": 458,
	"./state/reducers/initializer-reducer.tsx": 458,
	"./state/reducers/mint-reducer": 439,
	"./state/reducers/mint-reducer.tsx": 439,
	"./state/reducers/swap-reducer": 444,
	"./state/reducers/swap-reducer.tsx": 444,
	"./state/reducers/trade-reducer": 449,
	"./state/reducers/trade-reducer.tsx": 449,
	"./state/reducers/uniswap-minter-reducer": 440,
	"./state/reducers/uniswap-minter-reducer.tsx": 440,
	"./state/staking/actions": 917,
	"./state/staking/actions.ts": 917,
	"./state/staking/context": 145,
	"./state/staking/context.tsx": 145,
	"./state/staking/hooks": 424,
	"./state/staking/hooks.ts": 424,
	"./state/staking/middleware": 918,
	"./state/staking/middleware.ts": 918,
	"./state/staking/reducer": 343,
	"./state/staking/reducer.ts": 343,
	"./state/swap": 240,
	"./state/swap.tsx": 240,
	"./state/trade": 241,
	"./state/trade.tsx": 241,
	"./utils/canvas": 187,
	"./utils/canvas.js": 187,
	"./utils/format": 209,
	"./utils/format.js": 209,
	"./utils/getWeb3": 233,
	"./utils/getWeb3.js": 233,
	"./utils/proposal": 185,
	"./utils/proposal.tsx": 185,
	"./utils/serviceWorker": 919,
	"./utils/serviceWorker.js": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1517;